import React, { ReactNode } from 'react';
import { fetchPro } from 'resources/Pro/ProData';

import { useDataFetcherV2 } from 'components/Common/Data/useDataFetcher';
import { useInitAnalytics } from 'components/ProIdentity/useInitAnalytics';
import { useSetDatadogUserIdentity } from 'components/ProIdentity/useSetDatadogUserIdentity';
import { useSetSentryUserIdentity } from 'components/ProIdentity/useSetSentryUserIdentity';

type ProIdentity = {
  id: string;
  uuid: string;
  full_name: string;
  email: string;
  organization_uuid: string;
  organization_name: string;
  impersonated: boolean;
  is_admin: boolean;
  is_archived: boolean;
  is_super_pro: boolean;
};
const ProIdentity = ({ children }: { children: ReactNode }) => {
  const [doneFetching, pro] = useDataFetcherV2(fetchPro);

  useInitAnalytics(pro.email, pro.id);
  useSetSentryUserIdentity(doneFetching, pro);
  useSetDatadogUserIdentity(doneFetching, pro);

  return <>{children}</>;
};

export default ProIdentity;
